module.exports = "/fonts/materialdesignicons-webfont.ttf?fe1545ef4dd1eef2f1e25528898fc0b3";